import KycSummary from '@/components/timeline/components/message-summary/kyc-summary';
import {resourceTypes} from '@/components/timeline/resource-types';
import makeResourceRoute, {routableResourceTypes} from '@/components/timeline/components/message-summary/make-resource-route';

/**
 * Returns link component.
 * Input link object with placeholder data
 * Output Vue component/Button/vue-router etc.
 *
 * @param createElement
 * @param link
 * @param component
 * @param isDisabledLink
 * @return {*}
 */
export default function makeLinkComponent({
    createElement,
    link,
    component,
    isDisabledLink,
}) {
    if (isDisabledLink(link)) {
        return createElement('span', {class: ''}, link.placeholder);
    }

    /**
     * returns KYC summary button component (+ modal)
     */
    if (link.resourceType === resourceTypes.kycDocument) {
        return createElement(
            'span',
            {class: 'display-inline-block'},
            [
                createElement(KycSummary, {
                    props: {
                        entityId: link.resourceId,
                        placeholder: link.placeholder,
                    },
                    on: {
                        update: () => component.$emit('update'),
                    },
                }),
            ],
        );
    }

    /**
     * Returns link button with v-push
     */
    if (routableResourceTypes.includes(link.resourceType)) {
        return createElement('span', {
            class: '',

        },
        [
            createElement('router-link', {
                props: {
                    to: makeResourceRoute({
                        resourceType: link.resourceType,
                        resourceId: link.resourceId,
                    }),
                },
                'data-id': link.resourceId,
            }, link.placeholder),
        ]);
    }

    /**
     * By default returns span with placeholder
     */
    return createElement('span', {class: ''}, link.placeholder);
}
